import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  //   const reviewList = [
  //     {
  //       src: "/images/review1.png",
  //       txt: "갑자기 도어락이 안열려서 엄청 애먹었는데 빨리 해결해주셔서 감사합니다.",
  //     },
  //     {
  //       src: "/images/review2.png",
  //       txt: "결국.. ㅠㅠ 문을 따긴했지만 그래도 해결이 깔끔하게되서 다행이었습니다.",
  //     },
  //     {
  //       src: "/images/review3.png",
  //       txt: "도어락 번호판이 안눌려서 고생했는데 20분도 안되서 해결해주셨습니다",
  //     },
  //     {
  //       src: "/images/review4.png",
  //       txt: "와... 정말 골치아팠는데 시~원하게 열어주셔서 감사합니다.",
  //     },
  //     {
  //       src: "/images/review5.png",
  //       txt: "문고리 지금다시봐도 참 이쁘네용 ㅎㅎ 잘 마무리해주셔서 감사합니다.",
  //     },
  //     {
  //       src: "/images/review6.png",
  //       txt: "문이 잠겨서 업체를 불러도 해결이 안됬는데 너무 쉽게 해결해주셔서 깜짝 놀랬네요",
  //     },
  //     {
  //       src: "/images/review7.png",
  //       txt: "식당도어락이 갑자기 안열려서 장사를 못할지경이었는데 빨리와서 해결해주셨어요!",
  //     },
  //     {
  //       src: "/images/review8.png",
  //       txt: "도어락 새걸로 교체하려고 문의드렸는데 추천도 잘해주시고 설치도 잘해주셔서 너무 만족이었습니다.",
  //     },
  //     {
  //       src: "/images/review9.png",
  //       txt: "잠금장치가 너무 낡아서 새걸로 교체했는데 신속하게 해주셔서 너무 좋았어요",
  //     },
  //     {
  //       src: "/images/review10.png",
  //       txt: "열쇠구멍이 심하게 마모되서 항상 불편했는데 손잡이 깔끔하게 갈아주셔서 넘넘 감사합니다",
  //     },
  //     {
  //       src: "/images/review1.png",
  //       txt: "갑자기 도어락이 안열려서 엄청 애먹었는데 빨리 해결해주셔서 감사합니다.",
  //     },
  //     {
  //       src: "/images/review2.png",
  //       txt: "결국.. ㅠㅠ 문을 따긴했지만 그래도 해결이 깔끔하게되서 다행이었습니다.",
  //     },
  //     {
  //       src: "/images/review3.png",
  //       txt: "도어락 번호판이 안눌려서 고생했는데 20분도 안되서 해결해주셨습니다",
  //     },
  //     {
  //       src: "/images/review4.png",
  //       txt: "와... 정말 골치아팠는데 시~원하게 열어주셔서 감사합니다.",
  //     },
  //     {
  //       src: "/images/review5.png",
  //       txt: "문고리 지금다시봐도 참 이쁘네용 ㅎㅎ 잘 마무리해주셔서 감사합니다.",
  //     },
  //     {
  //       src: "/images/review6.png",
  //       txt: "문이 잠겨서 업체를 불러도 해결이 안됬는데 너무 쉽게 해결해주셔서 깜짝 놀랬네요",
  //     },
  //     {
  //       src: "/images/review7.png",
  //       txt: "식당도어락이 갑자기 안열려서 장사를 못할지경이었는데 빨리와서 해결해주셨어요!",
  //     },
  //     {
  //       src: "/images/review8.png",
  //       txt: "도어락 새걸로 교체하려고 문의드렸는데 추천도 잘해주시고 설치도 잘해주셔서 너무 만족이었습니다.",
  //     },
  //     {
  //       src: "/images/review9.png",
  //       txt: "잠금장치가 너무 낡아서 새걸로 교체했는데 신속하게 해주셔서 너무 좋았어요",
  //     },
  //     {
  //       src: "/images/review10.png",
  //       txt: "열쇠구멍이 심하게 마모되서 항상 불편했는데 손잡이 깔끔하게 갈아주셔서 넘넘 감사합니다",
  //     },
  //   ];

  const reviewList = [
    {
      src: "/images/review1.png",
    },
    {
      src: "/images/review2.png",
    },
    {
      src: "/images/review3.png",
    },
    {
      src: "/images/review4.png",
    },
    {
      src: "/images/review5.png",
    },
    {
      src: "/images/review1.png",
    },
    {
      src: "/images/review2.png",
    },
    {
      src: "/images/review3.png",
    },
    {
      src: "/images/review4.png",
    },
    {
      src: "/images/review5.png",
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div id="review" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div
        id="title"
        data-aos="fade-down"
        className="relative w-full h-fit text-center mb-5 lg:mb-10"
      >
        <h2 className="leading-none font-normal">
          몽땅을 이용해주신 고객님들의 실제 이용후기
        </h2>
        <p className="text-primary mb-5">- REVIEW -</p>
        <p className=" lg:text-xl text-[#9e9e9e]">
          100% 만족후기! 어떤 현장 어떤 서비스도 만족 시켜드리겠습니다.
        </p>
      </div>
      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full min-w-72 px-5 lg:px-0"
          >
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-10 max-w-44 mx-auto mb-2 animate-bounce ">
                <img
                  src="/images/star.png"
                  alt="star"
                  className=" relative w-full h-fit object-contain"
                />
              </div>
              <div className="relative w-full h-full pt-14 border-4 border-secondary p-3 rounded-xl">
                {/* <div className=" relative w-full h-28 text-center">
                  <p>{v.txt}</p>
                </div> */}
                <img
                  className="relative w-full h-auto  object-cover object-center"
                  src={v.src}
                  alt="review"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
